/**
 * API Configuration
 * Set REACT_APP_API_URL and REACT_APP_SITE_URL in production (Hostinger / CI build env).
 */

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://blogify-sooty-one.vercel.app/api';
const BASE_URL_WITHOUT_API =
  process.env.REACT_APP_BASE_URL || 'https://blogify-sooty-one.vercel.app';

const apiConfig = {
  BASE_URL: API_BASE_URL,
  BASE_URL_WITHOUT_API: BASE_URL_WITHOUT_API,
  TIMEOUT: 10000, // 10 seconds
};

export default apiConfig;


